<template>
  <App-Demanda-Editar-Produtos-Tabela class="dem-dev-itens"
    :cpntDemanda="cpntDemanda"
    :cpntDemandaId="cpntDemandaId"
    :cpntDemandaFlag="'resumo'"
    :cpntPDocNFEmitida="false"
    :cpntPDocDocs="''"
    :cpntIdCon="cpntIdCon"
    :cpntIdConPessoa="cpntIdConPessoa"
    :cpntIdConIdPais="cpntIdConIdPais"
    :cpntIdConUF="cpntIdConUF"
    :cpntPDocTp="cpntPDocTp"
    :cpntPDV="false"
    :cpntDemandaTotal="cpntDemandaTotal"
    :cpntFinStatus="'n'"
    :cpntIdConTpCon="cpntIdConTpCon"

    @DEMANDA_BUSCAR_VALORES="(callback) => { cpntDemDevAtualizarDadosDemanda(cpntDemandaId, callback) }"
    ref="ven_pro"
  ></App-Demanda-Editar-Produtos-Tabela>
</template>

<style scoped>
  .dem-dev-itens {
    width: 800px;
    margin: 0px auto;
    margin-bottom: 10px;
  }
</style>

<style>
</style>

<script>
  // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
  const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

  // INICIA O VUE
  export default {
    props: {
      cpntDemanda: {
        required: true,
        type: String
      },
      cpntDemandaId: {
        required: true,
        type: String
      },

      cpntIdCon: {
        required: true
      },
      cpntIdConPessoa: {
        required: true
      },
      cpntIdConIdPais: {
        required: true
      },
      cpntIdConUF: {
        required: true
      },
      cpntPDocTp: {
        required: true
      },
      cpntDemandaTotal: {
        required: true
      },
      cpntIdConTpCon: {
        required: true
      },
      
      cpntDemDevAtualizarDadosDemanda: {
        required: true
      },
      cpntDemDevSetarStatusGeral: {
        required: true
      }
    },
    components: {
      'App-Demanda-Editar-Produtos-Tabela': () => import('@/components/demanda/Editar/Produto/Demanda-Editar-Produtos-Tabela.vue')
    },
    methods: {
      demDevProdutoSalvar: function (callback, chaves = null, index = 0, _formData = []) {
        if (chaves === null) {
          // PEGA AS CHAVES EXISTENTES
          chaves = Object.keys(this.$refs.ven_pro.$refs)

          // DEIXA APENAS AS EDIÇÕES
          chaves = chaves.filter(item => item.indexOf('editar_linha_') !== -1 && [ '', null, undefined ].indexOf(this.$refs.ven_pro.$refs[item]) === -1)

          // CHAMA A FUNÇÃO PARA REINICIAR
          this.demDevProdutoSalvar(callback, chaves, index, _formData)
        } else if ((chaves.length === 0 || [ '', null, undefined ].indexOf(chaves[index]) !== -1)) {
          if (_formData.length === 0) {
            // this.demDevProdutoAtualizarFinalidadeEmissao(callback)
            callback()
          } else {
            // CONVERTE O VALOR EM LOT
            _formData = { lot: _formData }
            
            // 
            var router = ''

            // VERIFICA A DEMANDA QUE ESTÁ SENDO EXECUTADA
            switch (this.cpntDemanda) {
              // case 'venda':
              //   router = '/venda/produto'
              //   break
            
              case 'dev_cliente':
                router = '/demanda/dem-dev-cliente/dem-produto'
                break
            
              case 'dev_fornecedor':
                router = '/demanda/dem-dev-fornecedor/dem-produto'
                break

              // case 'compra':
              //   router = '/demanda/dem-compra/dem-produto'
              //   break
            }

            // FAZ A BUSCA DOS DADOS
            this.$store.state.comunicaAPI(router, 'PUT', _formData, (retorno) => {
              this.demDevProdutoTratarRetorno(() => {
                // this.demDevProdutoAtualizarFinalidadeEmissao(() => {
                //   this.cpntDemDevAtualizarDadosDemanda(this.cpntDemandaId, () => { callback() })
                // })
                this.cpntDemDevAtualizarDadosDemanda(this.cpntDemandaId, () => { callback() })
              }, retorno.lot)
            }, this.cpntDemDevSetarStatusGeral)
          }
        } else {
          // PEGA O NOME DA LINHA QUE SERÁ EDITADA
          var indexL = chaves[index]

          // MONTA O FORMULARIO PARA SALVAR
          this.$refs.ven_pro.$refs[indexL].demEdiProTabItemMontarFormularioApi((formData) => {
            if (Object.keys(formData).length === 0) {
              this.demDevProdutoSalvar(callback, chaves, (index + 1), _formData)
            } else {
              // PEGA A CHAVE REFERENCIA
              var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)
  
              // SETA O ID DA VENDA
              formData[chaveD] = this.$refs.ven_pro.$refs[indexL].cpntDemandaId
  
              // SETA O ID DO ITEM
              formData.id = this.$refs.ven_pro.$refs[indexL].cpntItemId

              // ADICIONA O VALOR NO FORMULARIO PRINCIPAL
              _formData.push(formData)

              // REINICIA O PROCESSO PARA FAZER O PROXIMO PRODUTO
              this.demDevProdutoSalvar(callback, chaves, (index + 1), _formData)
            }
          })
        }
      },
      demDevProdutoTratarRetorno: function (callback, vetor, index = 0, qtdeOK = 0, qtdeErro = 0, focus = '') {
        // VERIFICA SE TEM VALOR PARA TRABALHAR
        if ([ '', null, undefined ].indexOf(vetor) !== -1 || [ '', null, undefined ].indexOf(vetor[index]) !== -1) {
          if (qtdeOK === vetor.length) {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.msgWarn('WEB [200]: Ite' +  (vetor.length === 1 ? 'm' : 'ns') + ' atualizados com sucesso.', 'success')

            // EXECUTA O CALLBACK RECEBIDO
            callback()
          }
        } else {
          // INICIA O VETOR QUE SERÁ TRATADO
          var retorno = vetor[index]

          // VERIFICA A AÇÃO QUE DEVE REALIZAR
          switch (retorno.code) {
            case '200':
              // MANDA FECHAR O FORMULARIO DE EDIÇÃO
              this.$refs.ven_pro.$refs.tabela.cpntTabelaOnChangeLinhaAdicional(retorno.id)

              // SOMA A QUANTIDADE ENCONTRADA
              qtdeOK = (qtdeOK + 1)

              // REINICIA O PROCESSO DE VERIFICAÇÃO
              this.demDevProdutoTratarRetorno(callback, vetor, (index + 1), qtdeOK, qtdeErro)
              break

            default:
              // CRIA O NOME DA CHAVE DE EDIÇÃO
              var indexL = 'editar_linha_' + (retorno.id !== undefined ? retorno.id : retorno.ref.id)

              // TRATA O RETORNO RECEBIDO
              this.$store.state.FUN_API_RET_VALIDA(this.$refs.ven_pro.$refs[indexL], 'campos', retorno.message, retorno.code, this.$refs.ven_pro.$refs[indexL].campos, (index === vetor.length), (faltantes, vetorErro, _focus) => {
                // SETA O FOCUS NA ABA SOLICITADA
                if (_focus !== focus) {
                  // SETA O NOVO CAMPO QUE VAI RECEBER O FOCUS
                  focus = _focus

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  this.$refs.ven_pro.$refs[indexL].time = new Date().getTime()
                }
              
                // SOMA A QUANTIDADE ENCONTRADA
                qtdeErro = (qtdeErro + 1)

                // REINICIA O PROCESSO DE VERIFICAÇÃO
                this.demDevProdutoTratarRetorno(callback, vetor, (index + 1), qtdeOK, qtdeErro, focus)
              }, false, focus)
              break
          }
        }
      },
      demDevProdutoAtualizarFinalidadeEmissao: function (callback) {
        // INICIA A VARIAVEL QUE VAI RECEBER O ROTA DA DEMANDA
        var router = ''

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

        // INICIA O FORLULARIO QUE SERÁ ENVIADO PARA API
        var formData = {}

        // SETA O ID DA DEMANDA QUE DEVE ATUALIZAR
        formData[chaveD] = this.cpntDemandaId

        // CONVERTE O VALOR EM LOT
        formData = { lot: [ formData ] }

        // VERIFICA O PARAMETRO PARA CADA DEMANDA
        switch (this.cpntDemanda) {
          case 'dev_cliente':
            router = '/demanda/dem-dev-cliente/fin-emissao'
            break

          case 'dev_fornecedor':
            router = '/demanda/dem-dev-fornecedor/fin-emissao'
            break
        }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI(router, 'PUT', formData, (retorno) => {
          // PEGA O RETORNO RECEBIDO
          retorno = retorno.lot[0]

          // VERIFICA A AÇÃO QUE DEVE REALIZAR
          switch (retorno.code) {
            case '200':
              this.demDevProdutoVerificarProIdSf2(callback)
              break
          
            default:
              this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true)
              break
          }
        }, this.cpntDemDevSetarStatusGeral)
      },
      demDevProdutoVerificarProIdSf2: function (callback) {
        // INICIA A VERIFICAÇÕES
        var passou = true

        // VERIFICA SE TEM QUE VALIDAR OS DADOS
        if ([ '', null, undefined ].indexOf(this.$refs.ven_pro) === -1 && [ '', null, undefined ].indexOf(this.$refs.ven_pro.linha) === -1 && this.$refs.ven_pro.linha.length >= 1) {
          for (var index in this.$refs.ven_pro.linha) {
            if ([ '', null, undefined ].indexOf(this.$refs.ven_pro.linha[index].p_id_sf2) !== -1) {
              // SETA A VARIAVEL QUE ENCONTROU UM PROBLEMA
              passou = false
  
              // MANDA PARAR O PROCESSO
              break
            }
          }
        } else {
          passou = false
        }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        if (passou === false) {
          this.$store.state.msgWarn('WEB [406]: OPS! É necessário selecionar um caso para todos os itens desta devolução.', 'success')
        } else {
          callback()
        }
      }
    }
  }
</script>
